import http from "../../http";
import { API_URLs } from "../../CONSTANTS";

const addProductSteps_apis = API_URLs.addProductSteps;

export const apiCall_getMasterCategories = () => {
  return http.get(addProductSteps_apis.getMasterCategories);
};

export const apiCall_getSubCategories = (ParentCategoryId) => {
  return http.get(
    addProductSteps_apis.getSubCategories +
      "?ParentCategoryId=" +
      ParentCategoryId
  );
};

export const apiCall_getSubCategorieFeatures = (SubcategoryId) => {
  return http.get(
    addProductSteps_apis.getSubCategorieFeatures +
      "?SubcategoryId=" +
      SubcategoryId
  );
};

export const apiCall_getBrands = () => {
  return http.get(addProductSteps_apis.getBrands);
};

export const apiCall_createProduct = (data) => {
  console.log(data);

  /*
    ProductTitle: "hjhj"
    SubCategoryId: 4
    BrandId: 1
    Tags: null
    Images: [{"src":{},"id":0.9734532871952324}]
    SellerFeatures: "سسسسسسسسسس.333,"
    Description: "ییییییی"
  
    ProductSellers: [{"Title":"dfg","Quantity":"4","Metraj":"4","PaletId":9,"IsAvailable":false,"Discount":0,"Price":0}]
    Features: [{"1":2},{"2":"یییییییی"}]
    form.append(Features[0].FeatureId , 1)
    form.append(Features[0].FeatureValue , 1)
    form.append(Features[0].2, "یییییییی")
    */

  const form = new FormData();

  form.append("ProductTitle", data.ProductTitle);
  form.append("ExpirationTime", data.expirationTime);
  form.append("SubCategoryId", data.SubCategoryId);
  form.append("BrandId", data.BrandId);
  form.append("IsFori", data.IsFori);
  form.append("Discount", data.Discount);
  form.append("Description", data.Description);
  form.append("SellerFeatures", data.SellerFeatures);
  form.append("Tags", data.Tags);
  if (data?.Images?.length > 0) {
    data?.Images?.forEach((item, index) => {
      console.log("item.src");
      console.log(item.src);
      form.append("Images[" + index + "].item", item.src);
    });
  }
  if (data?.ProductSellers?.length > 0) {
    data?.ProductSellers?.forEach((item, index) => {
      form.append("ProductSellers[" + index + "].Title", item.Title);
      form.append("ProductSellers[" + index + "].Metraj", item.Metraj);
      form.append(
        "ProductSellers[" + index + "].IsAvailable",
        item.IsAvailable
      );
      form.append("ProductSellers[" + index + "].Discount", item.Discount);
      form.append("ProductSellers[" + index + "].Price", item.Price);
    });
  }
  if (data?.Features?.length > 0) {
    data?.Features?.forEach((item, index) => {
      const key = Object.keys(item)[0];
      form.append(
        "Features[" + index + "].FeatureId",
        key.toString().replace("keyValueFeature-", "")
      );
      if (key.startsWith("keyValueFeature-")) {
        form.append(
          "Features[" + index + "].FeatureValue",
          item[key.toString()]
        );
      } else {
        form.append(
          "Features[" + index + "].FeatureOptionId",
          item[key.toString()]
        );
      }
    });
  }

  return http.post(addProductSteps_apis.createProduct, form);
};

const createFormData = (data) => {
  const form = new FormData();
  Object.entries(data).forEach((item) => {
    form.append(item[0], JSON.stringify(item[1]));
  });
  return form;
};
